import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 1,
  class: "ms-2 text-small"
}
const _hoisted_2 = {
  class: "sidePanelFooter pb-3 border-top flex-grow-0 flex-shrink-1 d-flex flex-column align-items-center",
  style: {"text-align":"right"}
}
const _hoisted_3 = { class: "d-flex flex-row w-75 mt-2 gap-1" }
const _hoisted_4 = { class: "w-25 justify-content-end" }
const _hoisted_5 = { class: "d-flex flex-grow-1 align-items-center justify-content-end text-ss-grey-dark" }
const _hoisted_6 = { class: "w-25 justify-content-end" }
const _hoisted_7 = {
  key: 0,
  class: "d-flex flex-row w-75 gap-1"
}
const _hoisted_8 = { class: "w-25 justify-content-end" }

import CartProductList from './cartProductList.vue';
import { CCloseButton } from '@coreui/bootstrap-vue/src/components/close-button/CCloseButton';
import {
  COffcanvas,
  COffcanvasBody,
  COffcanvasHeader,
} from '@coreui/bootstrap-vue/src/components/offcanvas/index';
import {
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem,
  CDropdownDivider,
} from '@coreui/bootstrap-vue/src/components/dropdown/index';
import { CButton } from '@coreui/bootstrap-vue/src/components/button/index';

import { useCartStore } from './cartStore';
import { useAccountStore } from '../account/accountStore';
import { watch } from 'vue';


  const __default__ = {
    name: 'CartPanel',
    inheritAttrs: false,
    customOptions: {}
  }

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {


const $account = useAccountStore();
const $cartStore = useCartStore();

function showLogin() {
  $cartStore.hideCart();
  $account.showLogin();
}

watch(() => $account.isLoggedIn, (isLoggedIn) => {
  if (isLoggedIn) {
    window.current_user = $account.customerName;
    if (window._userMessage?.html) {
      window._userMessage.element.innerHTML = window._userMessage.html;
    }
  } else {
    window.current_user = void 0;
  }
});


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(COffcanvas), {
    visible: _unref($cartStore).cartVisible,
    placement: "end",
    backdrop: true,
    keyboard: true,
    onShow: _unref($cartStore).showCart,
    onHide: _unref($cartStore).hideCart
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(COffcanvasHeader), { class: "border-bottom" }, {
        default: _withCtx(() => [
          _createTextVNode(" Welcome " + _toDisplayString(_unref($account).customerName) + " ", 1 /* TEXT */),
          (_unref($account).isLoggedIn)
            ? (_openBlock(), _createBlock(_unref(CDropdown), {
                key: 0,
                class: "ms-2 dropdown-account"
              }, {
                default: _withCtx(() => [
                  _createVNode(_unref(CDropdownToggle), {
                    size: "sm",
                    class: "btn-account"
                  }, {
                    default: _withCtx(() => _cache[1] || (_cache[1] = [
                      _createTextVNode(" Account ")
                    ])),
                    _: 1 /* STABLE */
                  }),
                  _createVNode(_unref(CDropdownMenu), null, {
                    default: _withCtx(() => [
                      _createVNode(_unref(CDropdownItem), {
                        href: "/account",
                        onClick: _unref($cartStore).hideCart
                      }, {
                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                          _createTextVNode("My Account")
                        ])),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"]),
                      _createVNode(_unref(CDropdownDivider)),
                      _createVNode(_unref(CDropdownItem), {
                        onClick: _unref($account).logout
                      }, {
                        default: _withCtx(() => _cache[3] || (_cache[3] = [
                          _createTextVNode("Sign out")
                        ])),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["onClick"])
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                _: 1 /* STABLE */
              }))
            : (_openBlock(), _createElementBlock("span", _hoisted_1, [
                _createElementVNode("a", {
                  class: "text-ss-iris btn-outline-grey btn btn-sm",
                  href: "",
                  onClick: _withModifiers(showLogin, ["prevent"])
                }, "Sign in ")
              ])),
          _createVNode(_unref(CCloseButton), {
            class: "text-reset",
            onClick: _unref($cartStore).hideCart
          }, null, 8 /* PROPS */, ["onClick"])
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_unref(COffcanvasBody), null, {
        default: _withCtx(() => [
          _createVNode(CartProductList)
        ]),
        _: 1 /* STABLE */
      }),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "d-flex flex-grow-1 justify-content-end text-ss-grey-dark" }, " Subtotal ", -1 /* HOISTED */)),
          _createElementVNode("div", _hoisted_4, _toDisplayString(_unref($cartStore).subtotal), 1 /* TEXT */)
        ]),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref($cartStore).cartDiscounts, (discount, i) => {
          return (_openBlock(), _createElementBlock("div", {
            key: i,
            class: "d-flex flex-row text-small w-75 gap-1"
          }, [
            _createElementVNode("div", _hoisted_5, [
              _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-tag me-1" }, null, -1 /* HOISTED */)),
              _createTextVNode(_toDisplayString(discount.description), 1 /* TEXT */)
            ]),
            _createElementVNode("div", _hoisted_6, _toDisplayString(discount.formattedAmount), 1 /* TEXT */)
          ]))
        }), 128 /* KEYED_FRAGMENT */)),
        (_unref($cartStore).cartDiscounts.length)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _cache[6] || (_cache[6] = _createElementVNode("div", { class: "d-flex flex-grow-1 justify-content-end text-ss-grey-dark" }, " Discounted Subtotal ", -1 /* HOISTED */)),
              _createElementVNode("div", _hoisted_8, _toDisplayString(_unref($cartStore).discountedSubtotal), 1 /* TEXT */)
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("a", {
          class: "btn btn-secondary w-75 mt-2",
          href: "/cart/",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_unref($cartStore).hideCart && _unref($cartStore).hideCart(...args)))
        }, _cache[7] || (_cache[7] = [
          _createElementVNode("i", { class: "fa-duotone fa-cart-shopping-fast pe-2" }, null, -1 /* HOISTED */),
          _createTextVNode(" Checkout ")
        ]))
      ])
    ]),
    _: 1 /* STABLE */
  }, 8 /* PROPS */, ["visible", "onShow", "onHide"]))
}
}

})